import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import MapGL, { Marker } from 'react-map-gl'
import { Button, Divider, Icon, Tooltip } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { saveAccess } from 'core/lib'
import 'mapbox-gl/dist/mapbox-gl.css'

// The following is required to stop "npm build" from transpiling mapbox code.
import mapboxgl from 'mapbox-gl'
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default

function ShopInfo({ classes }) {
	const shop = useSelector(state => state.shop)
	const location = shop.location
	const [viewport, setViewport] = useState({
		latitude: location ? Number(location.lat) || 0 : 0,
		longitude: location ? Number(location.lng) || 0 : 0,
		zoom: 13,
		width: '100%',
		height: '100%',
	})
	const social = (shop.social_fb && shop.social_fb != '') || (shop.social_ig && shop.social_ig != '') || (shop.social_tw && shop.social_tw) || (shop.social_ln && shop.social_ln != '')

	useEffect(() => {
		saveAccess('shop-info')
	}, [])

	const changeViewport = (newViewport) => {
		setViewport(newViewport)
	}

	return (<div className={`${classes.page} ${classes.textPage} ${classes.shopInfoPage}`}>
		{location && <div className="mapContainer">
			<MapGL
				mapStyle="mapbox://styles/mapbox/streets-v10"
				mapboxAccessToken={'pk.eyJ1IjoicGFydGl0YXRyaXBsYSIsImEiOiJja2FvemFjM2cwOGJtMzBxbjM2N21zN3U1In0.Qs03Hv0o1QA9wzPTHzqxVg'}
				onViewportChange={changeViewport}
				{...viewport}
			>
				<Marker latitude={Number(location.lat || 0)} longitude={Number(location.lng || 0)}>
					<Tooltip title={shop.shop_name} aria-label="Negozio">
						<Icon className="mapIcon">store_mall_directory</Icon>
					</Tooltip>
				</Marker>
			</MapGL>
		</div>}

		<h2>{shop.shop_name}</h2>
		<div dangerouslySetInnerHTML={{
			__html: shop.shop_description
		}}></div>
		<Divider />

		{location && <p>
			<label>Dove siamo: </label><br/>
			{`${location.address} ${location.house_number} - ${location.postal_code} ${location.city} ${location.province_id != '' ? `(${location.province_id})` : ''}`}
		</p>}

		<p>
			<label>Email: </label>{shop.shop_email}<br/>
			<label>Telefono: </label>{shop.shop_phone}
		</p>

		{social && <div className="socialIcons">
			{shop.social_fb && shop.social_fb != '' && <a href={shop.social_fb} target="_blank"><i className="fab fa-facebook-f"></i></a>}
			{shop.social_ig && shop.social_ig != '' && <a href={shop.social_ig} target="_blank"><i className="fab fa-instagram"></i></a>}
			{shop.social_tw && shop.social_tw != '' && <a href={shop.social_tw} target="_blank"><i className="fab fa-twitter"></i></a>}
			{shop.social_ln && shop.social_ln != '' && <a href={shop.social_ln} target="_blank"><i className="fab fa-linkedin-in"></i></a>}
		</div>}

		<p className="phone">
			<Button variant="contained" color="primary" onClick={() => { window.location.href = `tel:${shop.shop_phone}`} }>Chiamaci</Button>
		</p>
	</div>)
}

export default withStyles(style)(ShopInfo)
